import React, { useContext, useEffect, useState } from 'react'
import { Translations } from '../services/TranslationService'
import Selectors from './Selectors'
import Button from '@3mcom/mds-library/dist/node/Button'
import Alert from '@3mcom/mds-library/dist/node/Alert'
import { trackPDPData } from '../services/TealiumService'
import { StateContext } from '../services/StateService'
import { PDP_SELECTORS_ID } from '../constants/PDPConstants'
import Icons from '@3mcom/mds-library/dist/node/Icons'
import usePDPProductType from '../hooks/usePDPProductType'

const SelectorsContainer = ({
    handleReset,
    prodOptButtonRef,
    handleProductSelectorRequest,
    clearAll
}) => {
    // const [displayViewAllOptionsButton, setDisplayViewAllOptionsButton] = useState(true)
    const translations = useContext(Translations)
    const {
        isParent,
        selectedOptions,
        moreOptions,
        errors,
        ctaInfo = {}
    } = useContext(StateContext)
    const { loadingCCWTBScript } = ctaInfo
    const { isParentWithHiddenSKUs } = usePDPProductType()

    const getNumberOfOptions = () => {
        let numberOfOptions
        if (selectedOptions?.totalSelected === moreOptions?.totalSelected) {
            numberOfOptions = translations.viewAllProductOptions.replace(
                '{number}',
                moreOptions?.totalSelected
            )
        } else {
            const key =
                selectedOptions?.totalSelected === 1
                    ? 'showProductOption'
                    : 'showProductOptions'
            numberOfOptions = translations[key].replace(
                '{number}',
                selectedOptions?.totalSelected
            )
        }
        return numberOfOptions
    }

    // useEffect(() => {
    //     const shouldHide =
    //         selectedOptions?.totalSelected === 1 &&
    //         !!document.getElementById('cci-widget')
    //     setDisplayViewAllOptionsButton(!shouldHide)
    // }, [loadingCCWTBScript, selectedOptions?.totalSelected])

    return (
        <div className="sps2-pdp_pSelector--selectors" id={PDP_SELECTORS_ID}>
            {clearAll && (
                <button
                    className={`mds-link_primary sps2-pdp_pSelector--selectors_clear ${
                        isParent
                            ? 'sps2-pdp_pSelector--selectors_clear--right'
                            : 'sps2-pdp_pSelector--selectors_clear--left'
                    }`}
                    onClick={() => {
                        handleReset()
                        trackPDPData(
                            `PDP Buying Zone Selectors Link Click: ${translations.clearAll}`,
                            'Engagement Event'
                        )
                    }}
                >
                    {translations.clearAll}
                </button>
            )}
            <Selectors />
            {/* Hidden-SKU parents use WTB ScreenTip as the primary CTA — the button is not needed */}
            {!isParentWithHiddenSKUs && (
                <div className="sps2-pdp_pSelector--selectors_btn--container">
                    {/* Rollback conditional button rendering after UAT feedback */}
                    {/* {displayViewAllOptionsButton && ( */}
                        <Button
                            tealiumTracking={true}
                            tealiumObj={{
                                event_name: `PDP Buying Zone Selectors Zone Button Click: ${getNumberOfOptions()}`,
                                event_type: 'Engagement Event',
                                experience_type: 'SNAPS2'
                            }}
                            ref={prodOptButtonRef}
                            buttonType="primary"
                            size="large"
                            className="sps2-pdp_pSelector--selectors_btn"
                            disabled={moreOptions?.displayTable === false}
                            onClick={() => {
                                // Params: isGetProductOptions, scrollToTable
                                handleProductSelectorRequest(
                                    moreOptions?.displayTable,
                                    moreOptions?.displayTable
                                )
                            }}
                        >
                            <Icons.icon_keyboard_arrow_down
                                className="icon-color_white"
                                width={20}
                                height={20}
                            />

                            {getNumberOfOptions()}
                        </Button>
                    {/* )} */}
                </div>
            )}
            {errors?.selectorsAjaxError && (
                <div className="sps2-pdp_ajaxError--centered mds-margin_small--bottom mds-margin_medium--top">
                    <Alert.InContext variant="error">
                        {translations.ajaxError}
                    </Alert.InContext>
                </div>
            )}
        </div>
    )
}

export default SelectorsContainer
